import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as userActions } from "../../../redux/modules/user";
import { NavLink } from "react-router-dom";
import SchoolBadge from "../SchoolBadge";
import "./style.css";
import "../../../index.css";
/**
 * 用于选科查询和神奇大学的列表的item
 */
class SchoolItem extends Component {
  render() {
    const { item, url, from } = this.props;
    return (
      <NavLink
        onClick={(event) => this.handleJump(event)}
        to={url + item.hashId + "?from=" + from}
        className="school_item_box"
      >
        <div className="school_inline_item">
          <SchoolBadge
            className="fl school_inline_item_img"
            src={item.img ? "https://resource.zhekaozhijia.com/badge/" + item.img : ""}
            name={item.name}
            placeholderFontSize={20}
          ></SchoolBadge>
          <div className="school_inline_item_div fl">
            <div>{item.name}</div>
            <div className="school_inline_item_div_bottom">
              <img
                className="school_inline_item_div_bottom_img fl"
                alt=""
                src={require("../../../images/school/position.png")}
              ></img>
              <div
                style={{ position: "relative", top: -2 }}
                className="fl major_left_5"
              >
                {item.province}
              </div>
              <img
                className="school_inline_item_div_bottom_img major_left_15 fl"
                alt=""
                src={require("../../../images/school/level.png")}
              ></img>
              <div
                style={{ position: "relative", top: -2 }}
                className="fl major_left_5"
              >
                {item.level}
              </div>
              {item.property != null ? (
                <div className="fl">
                  <img
                    className="school_inline_item_div_bottom_img major_left_15 fl"
                    alt=""
                    src={require("../../../images/school/property.png")}
                  ></img>
                  <div
                    style={{ position: "relative", top: -2 }}
                    className="fl major_left_5"
                  >
                    {item.property}
                  </div>
                </div>
              ) : (
                ""
              )}
              {item.tags.map((tag, index) => {
                if (tag === "双一流") {
                  return (
                    <div key={index} className="fl">
                      <img
                        className="school_inline_item_div_bottom_img major_left_15 fl"
                        alt=""
                        src={require("../../../images/school/dfr.png")}
                      ></img>
                      <div
                        style={{ position: "relative", top: -2 }}
                        className="fl major_left_5"
                      >
                        {tag}
                      </div>
                    </div>
                  );
                } else {
                  return <span key={index}></span>;
                }
              })}
            </div>
          </div>
        </div>
      </NavLink>
    );
  }
  handleJump = (event) => {
    let userInfo = this.props.userInfo;
    const { dispatch } = this.props;
    //如果没有登录 ，阻止它跳转，并且弹出登录框
    if (userInfo.isLogin === false) {
      event.preventDefault(); //阻止默认事件
      dispatch(userActions.setShowLogin(true));
    }
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};
export default connect(mapStateToProps)(SchoolItem);



// WEBPACK FOOTER //
// ./src/components/School/SchoolItem/index.js